import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const FulfilledByCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Fulfilled by", cell: (row) => row?.fulfilledBy ?? "" };
